import { useCallback, useEffect, useState } from "react";
import { clampZeiterfassungColumnWidth } from "@/pages/admin/zeiterfassung/columns";

function readStored(storageKey: string): Record<string, number> {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as Record<string, number>;
    const out: Record<string, number> = {};
    for (const [k, v] of Object.entries(parsed)) {
      const n = Number(v);
      if (Number.isFinite(n) && n > 0) out[k] = clampZeiterfassungColumnWidth(n);
    }
    return out;
  } catch {
    return {};
  }
}

export function useZeiterfassungColumnWidths(tableId: string) {
  const storageKey = `eh:zeiterfassung:${tableId}`;
  const [widths, setWidths] = useState<Record<string, number>>(() => readStored(storageKey));
  const saveTimerRef = { current: null as number | null };

  useEffect(() => {
    return () => {
      if (saveTimerRef.current) window.clearTimeout(saveTimerRef.current);
    };
  }, []);

  const onColumnWidthChange = useCallback(
    (key: string, width: number) => {
      const clamped = clampZeiterfassungColumnWidth(width);
      setWidths((prev) => {
        const next = { ...prev, [key]: clamped };
        if (saveTimerRef.current) window.clearTimeout(saveTimerRef.current);
        saveTimerRef.current = window.setTimeout(() => {
          try {
            localStorage.setItem(storageKey, JSON.stringify(next));
          } catch {
            /* ignore */
          }
          saveTimerRef.current = null;
        }, 500);
        return next;
      });
    },
    [storageKey],
  );

  return { widths, onColumnWidthChange };
}
